import { z } from 'zod';
import {
  FindingSeveritySchema,
  FindingStatusSchema,
} from '@terra/shared-schemas-orchestrator';

export const IntegrationFindingEventDataSchema = z.object({
  id: z.string().describe('Finding ID'),
  title: z.string().describe('Finding title'),
  description: z.string().describe('Finding description'),
  severity: FindingSeveritySchema.describe('Finding severity level'),
  status: FindingStatusSchema.describe('Finding status'),
  cvssScore: z.string().describe('CVSS score value'),
  cvssVector: z.string().describe('CVSS vector string'),
  poc: z.string().describe('Proof of concept'),
  business_impact: z.string().describe('Business impact description'),
  mitigation_plan: z.string().describe('Mitigation plan details'),
  discovery_date: z.string().describe('Discovery date in ISO format'),
  asset: z.string().describe('Primary asset ID associated with the finding'),
});
